import { Route, Routes } from 'react-router-dom';
import AboutPage from './components/Pages/AboutPage';
import ContactPage from './components/Pages/ContactPage';
import ErrorPage from './components/Pages/ErrorPage';
import Home from './components/Pages/Home';
import PortfolioDetailsPage from './components/Pages/PortfolioDetailsPage';
import ServiceDetailsPage from './components/Pages/ServiceDetailsPage';
import ServicesPage from './components/Pages/ServicesPage';
import PortfolioPage from './components/Pages/PortfolioPage';
import Layout from './components/Layout';
import CareersPage from './components/Pages/CareersPage';
import CareerDetailsPage from './components/Pages/CareerDetailsPage';
import CheckoutPage from './components/Pages/CheckoutPage';
import CheckoutSuccessPage from './components/Pages/CheckoutSuccessPage';
import TermsPage from './components/Pages/TermsPage';
import PrivacyPolicyPage from './components/Pages/PrivacyPolicyPage';
import RefundPolicyPage from './components/Pages/RefundPolicyPage';
import DisputeResolutionPage from './components/Pages/DisputeResolutionPage';
import PaymentFailedPage from './components/Pages/PaymentFailedPage';
import PaymentCancelledPage from './components/Pages/PaymentCancelledPage';
import HostedCheckoutPage from './components/Pages/HostedCheckoutPage';
import AdminPaymentsPage from './components/Pages/AdminPaymentsPage';
import AdminReconciliationPage from './components/Pages/AdminReconciliationPage';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="service" element={<ServicesPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route
            path="service/:serviceDetailsId"
            element={<ServiceDetailsPage />}
          />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route
            path="portfolio/:portfolioDetailsId"
            element={<PortfolioDetailsPage />}
          />
          <Route path="contact" element={<ContactPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="payment" element={<CheckoutPage />} />
          <Route path="checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="payment/success" element={<CheckoutSuccessPage />} />
          <Route path="payment/failed" element={<PaymentFailedPage />} />
          <Route path="payment/cancelled" element={<PaymentCancelledPage />} />
          <Route path="payment/hosted-checkout" element={<HostedCheckoutPage />} />
          <Route path="terms-and-conditions" element={<TermsPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="refund-policy" element={<RefundPolicyPage />} />
          <Route path="dispute-resolution" element={<DisputeResolutionPage />} />
          <Route path="admin/payments" element={<AdminPaymentsPage />} />
          <Route path="admin/reconciliation" element={<AdminReconciliationPage />} />
          <Route path="careers" element={<CareersPage />} />
          <Route path="careers/:jobId" element={<CareerDetailsPage />} />
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
